import request from 'local_modules/request'
import { constants, modals } from 'helpers'
import { reducers, getState } from 'redux/core'
import actions from 'redux/actions'


const setFetching = (isFetching) => reducers.marketplace.adminServiceConfigPage.setFetching(isFetching)

const fetchServices = () => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.environmentServices + `/${tool}?all=true`)
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.adminServiceConfigPage.setServices(data))
    .catch((error) => console.log(error))
}

const setServices = (services) => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.post(constants.marketplace.environmentServices + `/${tool}`, services)
    .then(({ data }) => data)
    .catch((error) => {
      actions.modals.open(modals.Dialog, {
        title: 'Ошибка',
        text: JSON.stringify({ error })
      })
      console.log(error)
    })
}


export default {
  setFetching,

  fetchServices,
  setServices,
}
